import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import classnames from 'classnames';

import PinIcon from '../../img/icons/BBicons_Pin';

import './refButtons.scss';

class AddToClipboardButton extends React.Component {
    static propTypes = {
        onAdd: PropTypes.func,
        onRemove: PropTypes.func,
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        hideLabel: PropTypes.bool
    };

    static defaultProps = {
        onAdd: undefined,
        onRemove: undefined,
        key: undefined,
        hideLabel: false
    };

    render() {
        if (this.isInClipboard()) {
            return (   
                <div className="ref-button ref-pin ref-label" title={this.props.translate('Search.Clipboard.Remove')} onClick={this.props.onRemove}
                    onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()} >
                    <PinIcon className='search-result-icon svg-standard-fill' />
                    {!this.props.hideLabel && <span className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })}><Translate id="Search.Clipboard.AlreadyIn" /></span>}
                </div>
            );
        }
        return (
            <div className="ref-button ref-pin" title={this.props.translate('Search.Clipboard.AddTooltip')} onClick={this.props.onAdd}
                onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()} >
                <PinIcon className='search-result-icon svg-standard-fill' />
                {!this.props.hideLabel && <span className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })}><Translate id="Search.Clipboard.Add" /></span>}
            </div>
        );
    }

    isInClipboard = () => {
        return this.props.clipboard.filter(x => x.entityId === this.props.entityId).length === 1
    }
}

export default withLocalize(connect(
    state => ({ ...state.search }),
    dispatch => bindActionCreators({}, dispatch)
)(AddToClipboardButton));